import { render, staticRenderFns } from "./VideoPlayerCard.vue?vue&type=template&id=4c78be6a&scoped=true"
import script from "./VideoPlayerCard.vue?vue&type=script&lang=js"
export * from "./VideoPlayerCard.vue?vue&type=script&lang=js"
import style0 from "./VideoPlayerCard.vue?vue&type=style&index=0&id=4c78be6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c78be6a",
  null
  
)

export default component.exports